import { Check } from "lucide-react";

const STEPS = [
  { id: 1, label: "Servicio" },
  { id: 2, label: "Detalles y extras" },
  { id: 3, label: "Tu presupuesto" },
];

export default function Stepper({ current }) {
  return (
    <div className="w-full" data-testid="calc-stepper">
      <div className="flex items-center justify-between gap-2">
        {STEPS.map((s, idx) => {
          const isActive = current === s.id;
          const isDone = current > s.id;
          return (
            <div key={s.id} className="flex-1 flex items-center gap-3 min-w-0">
              <div className="flex items-center gap-3 min-w-0">
                <div
                  className={[
                    "w-9 h-9 shrink-0 rounded-full grid place-items-center font-display font-semibold text-sm transition-all",
                    isDone ? "bg-[#004B87] text-white" : isActive ? "bg-[#004B87] text-white ring-4 ring-[#004B87]/15" : "bg-slate-100 text-slate-500"
                  ].join(" ")}
                  data-testid={`step-indicator-${s.id}`}
                >
                  {isDone ? <Check className="w-4 h-4" /> : s.id}
                </div>
                <div className="min-w-0">
                  <div className={"text-[10px] uppercase tracking-[0.18em] font-semibold " + (isActive || isDone ? "text-[#004B87]" : "text-slate-400")}>Paso {s.id}</div>
                  <div className={"text-sm font-medium truncate " + (isActive || isDone ? "text-slate-900" : "text-slate-500")}>{s.label}</div>
                </div>
              </div>
              {idx < STEPS.length - 1 && (
                <div className={"flex-1 h-px mx-2 " + (current > s.id ? "bg-[#004B87]" : "bg-slate-200")} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
